import script from "./StakingComplete.vue?vue&type=script&setup=true&lang=ts"
export * from "./StakingComplete.vue?vue&type=script&setup=true&lang=ts"

import "./StakingComplete.vue?vue&type=style&index=0&id=e546241a&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e546241a"]])

export default __exports__